<template>
    <div class="wrapper">
        <!-- <div class="div_input" v-if="vehiclePayment=='1'"> -->
        <div class="div_input">
            <div class="div_name">请输入车牌号补缴入场</div>
            <plate-input ref="plateInput1" :default-city="plateInitial"></plate-input>
            <div class="div_button" @click="getnoPlateManualInput">确认补缴入场</div>
        </div>
        <!-- <p v-else>未开启补缴功能</p> -->
    </div>
</template>

<script>
import { validatePlate } from '@/utils/plateValidator'
import { mapMutations, mapGetters } from "vuex";
import plateInput from '../weChat/components/plateInput.vue'

export default {
    data() {
        return {
            parkinglotInfo: {},
            plateNumber: "",
            vehiclePayment: "0",
            plateInitial: "",
            parkingId: 0,


        };
    },
    components: {
        plateInput
    },
    computed: {
        ...mapGetters(["parkinglotId", "doorId", "interfaceManner", "userOpenid", "buyId"])
    },

    mounted() {


        if (this.$route.query.parkinglotId && this.$route.query.areaId && (localStorage.getItem('userOpenId') || this.userOpenid || localStorage.getItem('userBuyId') || this.buyId)) {
            this.parkingId = this.$encryptUtil.decrypt(this.$route.query.parkinglotId);
            let areaId = this.$encryptUtil.decrypt(this.$route.query.areaId);
            this.$api.area.getBasicConfig(areaId).then(req => {
                if (req.data.code == 200) {
                    this.plateInitial = req.data.data.plateInitial
                    this.vehiclePayment = req.data.data.vehiclePayment
                }
            })

        }
    },
    methods: {
        ...mapMutations({
            setParkinglotId: "SET_PARKINGLOTID",
            setDoorId: "SET_DOORID",
            setAreaId: "SET_AREA_ID",
            setInterfaceManner: "SET_INTERFACEMANNER"
        }),


        getPlateNumber(data) {
            this.plateNumber = data
        },


        validOnlyOneTruckNo(value) {
            let xny = /^[京津沪渝冀豫云辽黑湘皖鲁新苏浙赣鄂桂甘晋蒙陕吉闽贵粤青藏川宁琼使领A-Z]{1}[A-Z]{1}(([0-9]{5}[DF]$)|([A-HJ-K][A-HJ-NP-Z0-9][0-9]{4}$))/;

            // 燃油车
            let ryc = /^[京津沪渝冀豫云辽黑湘皖鲁新苏浙赣鄂桂甘晋蒙陕吉闽贵粤青藏川宁琼使领A-Z]{1}[A-Z]{1}[A-HJ-NP-Z0-9]{4}[A-HJ-NP-Z0-9挂学警港澳]{1}$/;
            let isValid = true;
            if (value.length == 7) {
                if (!ryc.test(value)) isValid = false;
            } else if (value.length == 8) {
                if (!xny.test(value)) isValid = false;
            } else {
                isValid = false;
            }
            return isValid;
        },

        getnoPlateManualInput() {


            let params = {
                plateno: this.$refs.plateInput1.getPlateNumber(),
                parkinglotId: this.parkingId,
               
            }

            if (validatePlate(this.$refs.plateInput1.getPlateNumber()).valid) {
                this.$api.parkinglot.getVehicleOrder(params).then(res => {
                    if (res.data.code == 200 && res.data.data.orderInfo && res.data.data.pkParkrec) {

                        this.$router.push({ name: "SupplementaryPayment", query: params,params:{ isEntry:true} });
                    } else {
                        this.$createDialog({
                            type: "alert",
                            title: "提示",
                            content: "该车牌号无需补缴",
                            icon: "cubeic-alert"
                        }).show();
                    }
                });
            } else {
                this.$weui.alert('车牌号格式有误！')
            }

        },

    },
};
</script>

<style lang="stylus" scoped>
	@import '~common/stylus/variable';
	@import '~common/stylus/mixin';
    

    .wrapper {
		position: relative;
		width: 100%;
		height: 100%;
		background: #f5f5f5;
        
		.div_input {
			background: #ffffff;
			margin-top: 12px;
			padding: 20px;

			.div_name {
				font-size: 16px;
				font-weight: bold;
				line-height: 20px;
				margin-bottom: 25px;
			}

			.div_explain {
				background-color: #fff;
				margin-top: 12px;
				padding: 20px 20px 50px 20px;

				.div_name {
					font-size: 16px;
					margin-bottom: 15px;
					line-height: 20px;
					font-weight: bold;
				}

				.div_text p {
					margin: 0px;
					font-size: 14px;
					line-height: 28px;
				}
			}
			.div_button {
				color: #ffffff;
				width: 100%;
				height: 45px;
				background: #06ae56;
				box-shadow: 0px 5px 5px 0px rgba(84, 149, 246, 0.25);
				border-radius: 5px;
				font-size: 16px;
				display: flex;
				flex-direction: row;
				align-items: center;
				justify-content: center;
				letter-spacing: 3px;
				margin-top: 16px;
			}
		}
	}
    p{
        padding-top: 50%;
        padding-left: 25%;
    }
</style>
